export default "__VITE_ASSET__5089Qql2__"